import { render, staticRenderFns } from "./ClubsEstablish.vue?vue&type=template&id=7f84d5ee&scoped=true"
import script from "./ClubsEstablish.vue?vue&type=script&lang=js"
export * from "./ClubsEstablish.vue?vue&type=script&lang=js"
import style0 from "./ClubsEstablish.vue?vue&type=style&index=0&id=7f84d5ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f84d5ee",
  null
  
)

export default component.exports